// "Aproveite também" (visual original + descrição completa ao clicar no item, quando existir) na etapa "Confirmar" da página pública — LIBERADO PARA TODAS as empresas.
//
// Mesmo padrão de config/paymentSelectorFlags.ts, com chave PRÓPRIA (liga/desliga independente do seletor de pagamento): a decisão usa o id da empresa
// CARREGADA na página (resposta de /public/:slug) — nunca o usuário logado nem parâmetros da URL. Sem empresa identificada = visual original.
// Os itens, preços e promoções vêm do cadastro de cada empresa; este flag só escolhe o componente. companyIds: null = todas; enabled:false desliga tudo.

export interface AddonsListFlag {
  enabled: boolean;
  companyIds: number[] | null;
}

export const ADDONS_LIST_V2_FLAG: AddonsListFlag = { enabled: true, companyIds: null };

export function isAddonsListV2On(companyId: unknown, flag: AddonsListFlag = ADDONS_LIST_V2_FLAG): boolean {
  if (!flag.enabled) return false;
  if (typeof companyId !== 'number' && typeof companyId !== 'string') return false;
  if (typeof companyId === 'string' && !/^\d+$/.test(companyId.trim())) return false;
  const id = Number(companyId);
  if (!Number.isInteger(id) || id <= 0) return false; // empresa não identificada: visual original
  return flag.companyIds === null ? true : flag.companyIds.includes(id);
}
